<template>
  <div class="relative flex min-h-dvh w-full flex-row bg-surface">
    <slot />
  </div>
</template>

<script setup lang="ts"></script>
